module.exports = __webpack_public_path__ + "static/media/ship_maroon_flip.260fa093.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ship_maroon_flip.png
// module id = 211
// module chunks = 0